import { useQuery } from 'react-query';

import { getLargestDurationVariance as queryFn } from 'api/endPoints/getLargestDurationVariance';

export const useQueryLargestDurationVarianceTableData = (params) => {
    return useQuery(['largestDurationVarianceTableData', params], () => queryFn(params), {
        enabled: Boolean(params.compareVersionId) && Boolean(params.latestVersionId),
    });
};
